
//var axios = window.axios;

import cache   from 'fn/cache.js';
import get     from 'fn/get.js';
import update  from 'fn/lists/update.js';
import REQUEST, { requestPatch, requestGet, requestPost, requestDelete } from 'dom/request.js';

const assign = Object.assign;

//var axios      = window.axios;
var rslash     = /^\//;

var getState = cache(function(url) {
    return {
        // Chrome is a bit more tolerant of badly formed URLs than Edge.
        // Just sayin. Test in Edge.
        base: rslash.test(url) ?
            window.location.protocol + '//' + window.location.host + url :
            url,
        params:   {},
        requests: {},
        values:   [],
        models:   []
    };
});




// Aggregate date requests

function importAggregatedParams(state, value) {
    state.values.push(value);

    // Aggregate requests
    return (state.paramsRequest || (
        state.paramsRequest = Promise.resolve().then(function() {
            var url = new URL(state.base);

            // Edge <17 does not have searchParams interface
            if (url.searchParams) {
                url.searchParams.set(state.param, state.values);
            }
            else {
                url.search += '&' + state.param + '=' + state.values;
            }

            state.values.length = 0;
            state.paramsRequest = undefined;

            // Coerce to string to avoid passing an object to axios
            return request(url + '');
        })
    ))
    .then(function(data) {
        return data.filter(function(object) {
            return object[state.param] === value;
        });
    });
}

export function request(object) {
    return typeof object === 'string' ?
        requestGet(object) :
        requestGet(object.url) ;
}

export function patch(url, data) {
    //return axios
    //.patch(url, data, window.axiosConfig)

    return requestPatch(url, data)
    .then(get('data'))
    .then(function(data) {
        const state = getState(url);

        if (state.requests['']) {
            return state.requests[''].then(function(collection) {
                const model = collection.find(function(model) {
                    return model.id === url.id;
                });

                if (model) {
                    return assign(model, data)
                }

                collection.push(data);
                return data;
            });
        }

        const model = state.models.find(function(model) {
            return model.id === url.id;
        });

        if (model) {
            return assign(model, data);
        }

        state.models.push(data);
        return data;
    });
}

export function post(url, data) {
    //return axios
    //.post(url, data, window.axiosConfig)

    return requestPost(url, data)
    .then(get('data'))
    .then(function(model) {
        const state = getState(url);

        if (state.requests['']) {
            state.requests[''].then(function(collection) {
                collection.push(model);
            });
        }
        else {
            state.models.push(model);
        }

        return model;
    });
}

// Todo: "retrieve" was "import"... we can't call anything import in a module
// so we need to find an alternative name. load? fetch? Retrieve will do for
// just now, but think of a better name.

export function requestCollection(url) {
    const state = getState(url);
    const req   = state.requests[''] || (state.requests[''] = request(state.base));

    return state.models.length === 0 ?
        req :
        req.then(function(collection) {
            state.models.forEach(function(model) {
                const data = collection.find(function(model) {
                    return data.id === model.id;
                });

                if (data) {
                    assign(model, data);
                }
                else {
                    collection.push(model);
                }
            });

            state.models.length = 0;
            return collection;
        });
}

export function requestResource(url) {
    const rid      = /(\d+)\/$/;
    const result   = rid.exec(url);
    const id       = result && parseInt(result[1], 10) ;
    const location = url.replace(rid, '');
    const state    = getState(location);

    return state.requests[''] ?

        state.requests[''].then(function(collection) {
            return collection.find(function(model) {
                return model.id === id;
            }) || request(url).then(function(model) {
                collection.push(model);
                return model;
            });
        }) :

        request(url).then(function(model) {
            state.models.push(model);
            return model;
        }) ;
}


export function retrieve(url) {
    const rid      = /(\d+)\/$/;
    const result   = rid.exec(url);
    const id       = result && parseInt(result[1], 10) ;
    const location = url.replace(rid, '');
    const state    = getState(location);
    const req      = state.requests[''] || (state.requests[''] = request(state.base));

    return result ?
        req.then(function(collection) {
            return collection.find(function(model) {
                return model.id === id;
            });
        }) :
        req ;
}

export function retrieveParam(url, param, value) {
    var state = getState(url);

    // This is a potentially bad fudge, as new params cannot be
    // requested off the same base URL...
    state.param = param;
    return state.requests[value] || (
        state.requests[value] = importAggregatedParams(state, value)
    );
}
